import { render, staticRenderFns } from "./ChatFilePreviewModal.vue?vue&type=template&id=150f4e8b&scoped=true&"
import script from "./ChatFilePreviewModal.vue?vue&type=script&lang=js&"
export * from "./ChatFilePreviewModal.vue?vue&type=script&lang=js&"
import style1 from "./ChatFilePreviewModal.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150f4e8b",
  null
  
)

export default component.exports